<template>
    <v-container>
        <v-expansion-panels v-model="panel" class="my-4" accordion focusable hover light flat tile >
            <v-expansion-panel>
                <v-expansion-panel-header color="primary_2">
                          <h3 class="font-weight-bold white--text">Product Details</h3>
                          <div class="w-25 d-flex justify-end mx-5"><v-btn @click="openEditProductDetailsDialog()" class="edit-button" color="error" v-if="filters.allow_edit">Edit</v-btn></div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-simple-table>
                        <tbody>
                            <tr>
                                    <td class="font-weight-bold">Product ID</td>
                                    <td>{{ productDetail.id }}</td>
                                    <td class="font-weight-bold">Product Name</td>
                                    <td>{{ productDetail.name }}</td>
                                    <td class="font-weight-bold">Title</td>
                                    <td>{{ productDetail.title }}</td>                
                            </tr>
                            <tr>
                                <td class="font-weight-bold">Loan Type</td>
                                <td>{{ productDetail.product_type ? productDetail.product_type.loan_type : '-' }}</td>
                                <td class="font-weight-bold">Interest Rate</td>
                                <td>{{ productDetail.interest_rate }}</td>
                                <td class="font-weight-bold">Tenure</td>
                                <td>{{ productDetail.tenure }}</td>
                            </tr>
                            <tr>
                                <td class="font-weight-bold">Loan Amount</td>
                                <td>{{ productDetail.loan_upto }}</td>
                                <td class="font-weight-bold">Status</td>
                                <td>{{ productDetail.is_active ? 'Active' : 'Inactive' }}</td>
                                <td class="font-weight-bold">Created Date</td>
                                <td>{{ productDetail.created }}</td>
                            </tr>
                            <tr>
                                <td class="font-weight-bold">Priority</td>
                                <td>{{ productDetail.priority }}</td>
                                <td class="font-weight-bold">Modified</td>
                                <td>{{ productDetail.product_type ? productDetail.product_type.modified : '-' }}</td>
                                <td class="font-weight-bold">Logo</td>
                                <td><img v-if="productDetail.logo" :src="productDetail.logo" height="50" alt="product logo"></td>
                            </tr>
                            <tr>
                                <td class="font-weight-bold">Web Url</td>
                                <td @click="copyOfferLink(productDetail.web_url)" class="text-decoration-underline cursor-pointer font-italic">get_link</td>
                                <td class="font-weight-bold">UTM Link</td>
                                <td @click="copyOfferLink(productDetail.utm_link)" class="text-decoration-underline cursor-pointer font-italic">get_link</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-expansion-panels v-model="panel_2" class="my-4" accordion focusable hover light flat tile >
            <v-expansion-panel>
                <v-expansion-panel-header color="primary_2">
                    <h3 class="font-weight-bold white--text">Eligibility Details</h3>
                    <div class="w-25 d-flex justify-end mx-5"><v-btn @click="openEditEligibilityDialog()" class="edit-button" color="error" v-if="filters.allow_edit">Edit</v-btn></div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-simple-table>
                        <tbody>
                            <tr>
                                <td class="font-weight-bold">Eligibility ID</td>
                                <td>{{ eligibility_details.id }}</td>
                                <td class="font-weight-bold">Product Name</td>
                                <td>{{ eligibility_details.product_name }}</td>
                                <td class="font-weight-bold">product Type</td>
                                <td>{{eligibility_details.product_type_name }}</td>              
                            </tr>
                            <tr>
                                <td class="font-weight-bold">Minimum Age</td>
                                <td>{{ eligibility_details.minimum_age }}</td>
                                <td class="font-weight-bold">Maximum Age</td>
                                <td>{{ eligibility_details.maximum_age }}</td>
                                <td class="font-weight-bold">Employment Type</td>
                                <td>
                                    <v-chip
                                        v-for="item in formatMultiValueList(eligibility_details.employment_type)"
                                        :key="'employment-' + item"
                                        small
                                        class="ma-1"
                                        color="primary_2"
                                        text-color="white"
                                    >
                                        {{ item }}
                                    </v-chip>
                                    <span v-if="!formatMultiValueList(eligibility_details.employment_type).length">-</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="font-weight-bold">Salary Type</td>
                                <td>
                                    <v-chip
                                        v-for="item in formatMultiValueList(eligibility_details.salary_type)"
                                        :key="'salary-' + item"
                                        small
                                        class="ma-1"
                                        color="primary_2"
                                        text-color="white"
                                    >
                                        {{ item }}
                                    </v-chip>
                                    <span v-if="!formatMultiValueList(eligibility_details.salary_type).length">-</span>
                                </td>
                                <td class="font-weight-bold">Minimum Income</td>
                                <td>{{ eligibility_details.minimum_income }}</td>
                                <td class="font-weight-bold">Maximum Income</td>
                                <td>{{ eligibility_details.maximum_income }}</td>
                            </tr>
                            <tr>
                                <td class="font-weight-bold">Cibil Score</td>
                                <td>{{ eligibility_details.cibil_score }}</td>
                                <td class="font-weight-bold"> Check Pin Code Eligibility</td>
                                <td class="font-weight-bold">
                                    <v-form ref="pinCodeForm" v-model="pinCodeValid">
                                        <div class="d-flex align-center">
                                            <v-text-field
                                                class="mt-2"
                                                v-model="pincode"
                                                @input="onPincodeInput"
                                                dense

                                                maxlength="6"
                                                :rules="$rules.PIN_CODE"
                                                hide-details
                                                placeholder="Enter pin code"
                                                solo
                                            />
                                            <v-btn
                                                class="ml-2 mt-2"
                                                color="primary"
                                                @click="checkPinCodeServiceAbility()"
                                            >
                                                check
                                            </v-btn>
                                        </div>
                                    </v-form>
                                </td>
                                <td class="font-weight-bold" :style="{ color: serviceabilityColor }" v-if="serviceability_loading">{{ is_serviceable ? 'Serviceable' : 'Not Serviceable' }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <editProductDetails ref="editProductDetails" @updated="onProductUpdated" />
        <editEligibility @reload="get_eligibility_details()" ref="editEligibility" />
    </v-container>    
</template>
<script>
import { mapGetters } from "vuex";
import editProductDetails from "../../components/products/editProductDetails.vue";
import editEligibility from "../../components/products/editEligibility.vue";
export default {
    components: {
        editProductDetails,
        editEligibility
    },
    data() {
        return {
            productDetail: {},
            eligibility_details: [],
            panel: 0,
            serviceabilityColor: 'green',
            serviceability_loading: false,
            is_serviceable: false,
            pinCodeValid: false,
            pincode: '',
            panel_2: 0,

        };
    },
    mounted() {
        if (!this.filters.productDetail || !this.filters.productDetail.id) {
            this.$router.push('/products');
            return;
        }
        this.productDetail = this.filters.productDetail;
        this.get_eligibility_details();
    },
    computed: {
        ...mapGetters({
            filters: "product/getFilters",
        }),
    },
    methods: {
        formatMultiValueList(value) {
            if (!value) {
                return [];
            }
            if (Array.isArray(value)) {
                return value.filter(Boolean);
            }
            if (typeof value === "string") {
                return value.split(",").map((item) => item.trim()).filter(Boolean);
            }
            return [String(value)];
        },
        get_eligibility_details() {
            const self = this; 
            self.table_loading = true;
            const param = {
                product_id: self.productDetail.id
            }
            const successHandler = (response) => {
                self.eligibility_details = response.data.result[0];
            };
            const finallyHandler = () => {
                self.table_loading = false;
            }
            self.request_GET(
                self,
                self.$urls.GET_PRODUCT_ELIGIBILITY_DETAILS,
                param,
                successHandler,
                null,
                null,
                finallyHandler
            );
        },
        onPincodeInput(value) {
            const numeric = (value || '').replace(/\D/g, '').slice(0, 6);
            this.pincode = numeric;
        },
        checkPinCodeServiceAbility() {
            if (!this.$refs.pinCodeForm.validate()) {
                this.$store.dispatch("snackbar/setSnackbar", {
                    flag: true,
                    text: "Enter a valid pin code",
                    color: "error",
                });
                return;
            }
            const self = this;
            let formData = {
                product_id: self.productDetail.id,
                pincode: self.pincode
            }
            const successHandler = (response) => {
                const detail = response && response.data ? response.data.detail : "";
                if (detail && String(detail).toLowerCase() !== "success") {
                    self.showSnakeBar("error", detail);
                    self.serviceability_loading = false;
                    return;
                }
                self.serviceability_loading = true;
                self.is_serviceable = response.data.result.is_serviceable;
                self.serviceabilityColor = response.data.result.color || (self.is_serviceable ? "green" : "red");

                self.showSnakeBar(
                    self.is_serviceable ? "success" : "error",
                    self.is_serviceable
                        ? "Pincode is serviceable"
                        : "Pincode is not serviceable"
                );
            };
            const errorHandler = (error) => {
                self.serviceability_loading = false;
                const message =
                    self.getApiErrorMessage(error) || "Failed to check pincode eligibility";
                self.showSnakeBar("error", message);
            };
            const finallyHandler = () => {
                self.table_loading = false;
            };
            self.request_POST(
                self,
                self.$urls.CHECK_PIN_CODE_SERVICE_ABILITY,
                formData,
                successHandler,
                null,
                errorHandler,
                finallyHandler
            );
        },
        copyOfferLink(url) {
            if(url){
                navigator.clipboard.writeText(url);
                this.$store.dispatch("snackbar/setSnackbar", {
                flag: true,
                text:"Link Copied",
                color: "success",
                });
            } else {
                this.$store.dispatch("snackbar/setSnackbar", {
                flag: true,
                text:"Link Not Found",
                color: "error",
                });
            }
        },
        openEditProductDetailsDialog() {
            this.panel = 1;
            this.$refs.editProductDetails.openDialog(this.productDetail);
        },
        openEditEligibilityDialog() {
            this.panel_2 = 1;
            this.$refs.editEligibility.openDialog(this.eligibility_details);
        },
        onProductUpdated() {
            this.get_products_list();
        },
        get_products_list() {
            const self = this;
            const param = {
                search: "",
                page_number: 1,
            };
            const successHandler = (response) => {
                const products = response.data.result.data || [];
                const updatedProduct = products.find(
                    (product) => product.id === self.productDetail.id
                );
                if (updatedProduct) {
                    self.productDetail = updatedProduct;
                    self.filters.productDetail = updatedProduct;
                }
            };
            self.request_GET(
                self,
                self.$urls.GET_ADMIN_PRODUCT_LIST,
                param,
                successHandler,
                null,
                null,
                null
            );
        }
    },
};
</script>
<style>

</style>